<template>
  <div>
    <div class="setting-wrap">
      <div class="wrap-title" style="width:100%">
        メンバー管理
        <div class="flex-space"></div>

        <div class="report-title-num-box">
          <div class="report-title-num">
            メンバー数
            <div v-if="manage_member_limit_num !== null" class="report-title-num-bottom">{{ member_num }} / {{ manage_member_limit_num + 1}}</div>
            <div v-else class="report-title-num-bottom" style="margin: 0 auto;">{{ member_num }}</div>
          </div>          
        </div>
        
        <el-tooltip content="メンバーの上限数に達しています" v-bind="showAddMemberTip">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addMember()" v-bind="addMemberEnabled" >メンバーアカウントを作成
          </el-button>
        </el-tooltip>
        
      </div>
      <div class="data-table-member">
        <div class="data-table-th-bio">メンバー</div>
        <div class="data-table-invoice-120">メンバータイプ</div>
        <div class="data-table-th-400">アクセス権限</div> 
        <div class="data-table-th-80" v-if="permission">編集</div>
      </div>
      <div class="data-table-member-tr" v-for="(member, index) in member" :key="index">
        <div class="data-table-th-bio">
          <div class="setting-member-th">
            <el-image :src="member.img_url" class="setting-member-profile small setting" :class="permission ? 'pointer' : ''" @click="permission ? openMemberModal(member.person_id, index) : ''">
              <div slot="error" class="setting-member-noimg small setting" :class="permission ? 'pointer' : ''" @click="permission ? openMemberModal(member.person_id, index) : ''">{{ member.person_name | firstLetter }}</div>
            </el-image>
            <div style="display: flex; flex-flow:column; margin-left:20px">
              <div style="color:#333;" :class="permission ? 'pointer' : ''" @click="permission ? openMemberModal(member.person_id, index) : ''">{{ member.person_name }}<span v-if="member.myself"> (自分)</span></div>
              <div style="margin-top: 5px; font-size:10px">
                <span style="color: #999;" v-if="member.is_registered">{{ member.email }}</span>
                <span class="pointer" style="color: #f56c6c" v-else @click="noRegisterAlert()">
                  <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 3px;" />
                  <span style="color: #999">メールアドレス・パスワードが設定されていません</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="data-table-invoice-120" style="font-size:11px">
          <span v-if="member.admin_member">
            <font-awesome-icon :icon="['far', 'shield-check']" style="margin-right: 3px;" />
            <span v-if="member.super_admin_member">スーパー</span>管理者
          </span>
          <span v-else>メンバー</span>
        </div>
        <div class="data-table-th-400">
          <div v-if="member.permitted_jp" class="member-permission">
            <div v-for="(permission, index) in member.permitted_jp" :key="permission.id" class="member-permission">
              <div>{{permission}}</div>
              <div v-show="index != (member.permitted_jp.length-1)" class="member-permission-divider"></div>
            </div>
          </div>
        </div>
        <div class="data-table-th-80" v-if="permission"><el-button type="info" size="mini" @click="openMemberModal(member.person_id, index)">編集</el-button></div>
      </div>
    </div>

    <memberEdit :person_id="person_id" :index="index" :member_modal.sync="member_modal" @loadMember="loadMember" v-if="permission"/>
    <memberAdd :member_add_modal.sync="member_add_modal" v-if="permission"/>

    <unpermittedDrawer :unpermitted_drawer.sync="unpermitted_drawer" :type="unpermitted_type"/>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const loadMemberAPI = root + "/api/member/load_member";
import memberEdit from "./member_edit";
import memberAdd from "./member_add";
import unpermittedDrawer from "./../unpermitted_drawer"
import { handleApiResponse, ERROR_MESSAGES } from "@/components/common/responseHelper";

export default {
  name: "Member",
  components: {
    memberEdit,
    memberAdd,
    unpermittedDrawer
  },
  props: [],
  data() {
    return {
      member: [],
      member_num: 0,
      loading: false,
      person_id: 0,
      index: -1,
      member_modal: false,
      member_add_modal: false,
      unpermitted_drawer: false,
      unpermitted_type: "",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    permission() {
      if (this.$store.state.permission.company_setting) {
        return this.$store.state.permission.company_setting.access;
      } else {
        return false
      }
    },
    service_plan() {
      return this.$store.state.service_plan;
    },
    manage_member_limit_num() {
      return this.$store.state.manage_member_limit_num ?? this.service_plan.manage_member_limit_num;
    },
    checkMemberLimit() {
      if (this.manage_member_limit_num === null) return false;
      return this.member_num >= (this.manage_member_limit_num + 1) ? true : false;
    },
    addMemberEnabled() {
      return this.checkMemberLimit
        ? { disabled: true }
        : { disabled: false }
    },
    showAddMemberTip() {
      return this.checkMemberLimit
        ? { disabled: false }
        : { disabled: true }
    },
  },
  mounted() {
    this.loadMember();
  },
  methods: {
    loadMember() {
      this.axios
        .get(loadMemberAPI, {
          params: {
            token: this.token,
            user_token: this.user_token,
            type: "setting",
          },
        })
        .then((response) => {
          if (handleApiResponse(response)) {
            console.error(ERROR_MESSAGES.DATA_FETCH_ERROR);
            return;
          }
          this.member = response.data.member;
          this.member_num = response.data.member.length;
          this.target_client = response.data.target_client;
        });
    },
    addMember() {
      if (this.permission) {
        this.member_add_modal = true;
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    noRegisterAlert(){
        this.unpermitted_type = "noregister"
        this.unpermitted_drawer = true
    },
    openMemberModal(person_id, index) {
      this.person_id = String(person_id);
      this.index = index;
      this.member_modal = true;
    },
  },
  watch: {},
  filters: {
    firstLetter(val) {
      return val.slice(0, 1);
    },
  },
};
</script>
